import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isFinite from 'lodash-es/isFinite';
import { isStringFalse } from 'helpers/boolean';
import { InterpolateVariables } from 'providers/ContextVariables';
import { CmsModules, CmsModuleShape } from 'containers/CmsPage/CmsModules';

/**
 * This module is used so we can provide two text modules in Contentful where one is the
 * default text module and the other is the dynamic text module. We show the default text
 * module depending if the passed in context variable (prop.conditionalVariable) is truthy or
 * not. We also know which text module is the default because the name should match the name
 * of the default text module (prop.defaultTextModule).
 * https://app.contentful.com/spaces/ew96z4wsnz93/content_types/conditionalText/fields
 */

export class CmsConditionalText extends Component {
  getCmsModule(isInterpolatedConditional) {
    const { defaultTextModule, modules } = this.props;

    const shouldShowDynamicConditional = this.isInterpolatedConditionalTruthy(isInterpolatedConditional);
    return shouldShowDynamicConditional
      ? modules.filter(textModules => textModules.props.name !== defaultTextModule)
      : modules.filter(textModules => textModules.props.name === defaultTextModule);
  }

  isInterpolatedConditionalTruthy(isInterpolatedConditional) {
    let isValTruthy;
    const isInterpolatedConditionalNum = parseInt(isInterpolatedConditional, 10);
    if (isFinite(isInterpolatedConditionalNum)) {
      isValTruthy = isInterpolatedConditionalNum > 0;
    } else {
      isValTruthy = isStringFalse(isInterpolatedConditional) ? false : isInterpolatedConditional;
    }
    return !!isValTruthy;
  }

  render() {
    const { conditionalVariable } = this.props;
    return (
      <InterpolateVariables>
        {interpolator => {
          const interpolatorVar = interpolator(conditionalVariable);
          const cmsModule = this.getCmsModule(interpolatorVar);
          return <CmsModules modules={cmsModule} />;
        }}
      </InterpolateVariables>
    );
  }
}

CmsConditionalText.propTypes = {
  conditionalVariable: PropTypes.string.isRequired,
  defaultTextModule: PropTypes.string.isRequired,
  modules: PropTypes.arrayOf(CmsModuleShape).isRequired,
};
